import NumbersMixin from './NumbersMixin';
import FormatMixin from './FormatMixin';

export default {
  mixins: [NumbersMixin, FormatMixin],
  methods: {
    calculateInstallments(paymentMode, total) {
      const range = this.getRange(parseFloat(this.valorUS(total)), paymentMode.repeatTimes);

      return this.setRangeDates(paymentMode, range);
    },
    getRange(total, repeatTimes) {
      const partialValue = this.divide(total, repeatTimes);
      const range = Array.from({ length: repeatTimes }, () => ({ value: partialValue }));

      const rest = this.subtract(total, this.multiply(partialValue, repeatTimes));
      range[0].value = this.add(partialValue, rest);
      return range;
    },
    setRangeDates(paymentMode, range) {
      const increment = this.getIncrement(paymentMode.repeatType);

      let currentIncrement = Array.isArray(increment) ? increment[0] : increment;
      const offsetDay = paymentMode.requiresEntryPayment ? 0 : currentIncrement.value;

      let currentDate = this.$moment().add(offsetDay, currentIncrement.period);
      const rangeWithDates = range.map((portion, i) => {
        if (i === 0) {
          return {
            ...portion,
            date: currentDate.format('YYYY-MM-DD'),
          };
        }

        if (Array.isArray(increment)) {
          currentIncrement = increment[i];
        }

        currentDate = currentDate.add(currentIncrement.value, currentIncrement.period);

        return {
          ...portion,
          date: currentDate.format('YYYY-MM-DD'),
        };
      });

      return rangeWithDates;
    },
    getIncrement(repeatType) {
      if (!repeatType || !repeatType.modifier) {
        return {
          value: 1,
          period: 'month',
        };
      }

      if (Array.isArray(repeatType.modifier)) {
        const increments = [];
        repeatType.modifier.forEach((modifier) => {
          increments.push({
            value: parseInt(modifier.periodQty, 10),
            period: modifier.periodName,
          });
        });

        return increments;
      }

      return {
        value: parseInt(repeatType.modifier.periodQty, 10),
        period: repeatType.modifier.periodName,
      };
    },
    calcTotalRange(range) {
      return range.reduce((acc, obj) => acc + this.valorUS(obj.value), 0);
    },
  },
};
